import {returnDueLabel} from '@pocketbuy/outdoor-shared-utils';

export function salesDeadline(value?: string, timeZone?: string, reference = new Date()) {
  if (!value || !timeZone || !Number.isFinite(new Date(value).getTime())) {
    return {text: 'Deadline unavailable', overdue: false};
  }
  const label = returnDueLabel(value, timeZone, reference);
  const date = new Intl.DateTimeFormat('en-GB', {timeZone, day: 'numeric', month: 'short'}).format(new Date(value));
  const overdue = label === 'Return overdue';
  return {text: overdue ? `Overdue · Due ${date}` : label === 'Return today' ? 'Due today' : `Due ${date}`, overdue};
}
